import { useState, useEffect } from 'react';
import { useAuth } from './useAuth.ts';
import { useApi } from './useApi.ts';
import { useProfileStore } from './useProfileStore.ts';

interface ProfileState {
  username: string | null;
  avatarFilename: string | null;
  isLoading: boolean;
}

export function useProfile(): ProfileState {
  const { isAuthenticated, isLoading: authLoading } = useAuth();
  const { getMe } = useApi();
  const version = useProfileStore((s) => s.version);
  const [username, setUsername] = useState<string | null>(null);
  const [avatarFilename, setAvatarFilename] = useState<string | null>(null);
  const [isLoading, setIsLoading] = useState(false);

  useEffect(() => {
    if (authLoading || !isAuthenticated) {
      setUsername(null);
      setAvatarFilename(null);
      return;
    }
    setIsLoading(true);
    getMe()
      .then((p) => {
        setUsername(p.username);
        setAvatarFilename(p.avatarFilename);
      })
      .catch(() => {
        setUsername(null);
        setAvatarFilename(null);
      })
      .finally(() => setIsLoading(false));
  }, [isAuthenticated, authLoading, getMe, version]);

  return { username, avatarFilename, isLoading };
}
